import * as mutation from "./mutation-types";
import { stateMerge } from "vue-object-merge";
import { getBlankRecord } from "./helpers";
import { getInitialState, getUnloadedState } from "./state";

export const mutations = {
  [mutation.STATE_RESET](state) {
    stateMerge(state, getInitialState());
  },
  [mutation.STATE_UNLOAD](state) {
    stateMerge(state, getUnloadedState());
  },
  [mutation.STATE_HIDE_ERROR](state, hideArgument) {
    stateMerge(state[hideArgument], { error: { show: false } });
  },

  [mutation.VIEW_STARTED](state, id) {
    state.listing.loading = true;
    state.listing.levyCollectionId = id;
  },
  [mutation.VIEW_FAILED](state) {
    state.listing.loading = false;
  },
  [mutation.VIEW_SUCCEEDED](state, riskFactors) {
    state.listing.loading = false;
    state.listing.loaded = true;
    state.listing.data = riskFactors;
  },

  [mutation.EDIT_SET_DATA](state, { field, value }) {
    state.edit.data[field] = value;
  },
  [mutation.EDIT_GET_STARTED](state, { levyCollectionId, riskFactorId }) {
    state.edit.levyCollectionId = levyCollectionId;
    state.edit.riskFactorId = riskFactorId;
    state.edit.loading = true;
    state.edit.error.show = false;
    state.edit.data = getBlankRecord();
  },
  [mutation.EDIT_GET_FAILED](state) {
    state.edit.loading = false;
  },
  [mutation.EDIT_GET_SUCCEEDED](state, data) {
    state.edit.loading = false;
    state.edit.data = data;
  },

  [mutation.EDIT_SAVE_STARTED](state) {
    state.edit.saving = true;
    state.edit.error.show = false;
  },
  [mutation.EDIT_SAVE_FAILED](state, error) {
    state.edit.saving = false;
    state.edit.error.show = true;
    state.edit.error.details = error;
  },
  [mutation.EDIT_SAVE_SUCCEEDED](state) {
    state.edit.saving = false;
  },

  [mutation.CREATE_INITIALISE](state, riskFactorType) {
    stateMerge(state.create.data, getBlankRecord());
    state.create.data.type = riskFactorType;
  },
  [mutation.CREATE_SET_DATA](state, { field, value }) {
    state.create.data[field] = value;
  },
  [mutation.CREATE_STARTED](state) {
    state.create.saving = true;
  },
  [mutation.CREATE_SUCCEEDED](state) {
    state.create.saving = false;
  },
  [mutation.CREATE_FAILED](state, error) {
    state.create.saving = false;
    state.create.error.show = true;
    state.create.error.details = error;
  },

  [mutation.DELETE_STARTED](state) {
    state.delete.processing = true;
  },
  [mutation.DELETE_SUCCEEDED](state) {
    state.delete.processing = false;
  },
  [mutation.DELETE_FAILED](state, error) {
    state.delete.processing = false;
    state.delete.error.show = true;
    state.delete.error.details = error;
  }
};
